var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactUs1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 220,
    viewBox: "0 0 133 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.257 184.111H96.7153V151.899H128.927L127.257 184.111Z",
    fill: "#82B5A5",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.802 184.111H91.0142V151.899H123.225L124.802 184.111Z",
    fill: "#82B5A5",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.939 116.556C127.721 111.873 134.942 101.812 130.688 92.7828C128.602 93.0146 125.496 94.1737 125.496 94.1737L125.809 89.8271C122.899 90.8471 114.89 97.0946 111.447 100.027C60.7952 143.261 61.8384 146.263 68.5727 155.107C75.307 163.951 94.3161 160.3 107.507 149.613C120.709 138.949 124.939 116.556 124.939 116.556Z",
    fill: "white",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.827 125.263C98.5938 92.009 83.2358 94.7793 75.7481 99.5895C66.3943 105.594 69.6629 120.129 79.2601 134.142C83.9544 141.004 93.459 147.425 101.932 152.201",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.827 125.263C98.5938 92.009 83.2358 94.7793 75.7481 99.5895C66.3943 105.594 69.6629 120.129 79.2601 134.142C83.9544 141.004 93.459 147.425 101.932 152.201",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1995 76.3835C20.1583 62.1962 23.1836 53.6653 26.6377 42.0164C33.6965 18.2435 54.6529 11.8801 71.0308 19.901C87.4088 27.9219 83.5259 49.6664 83.5259 49.6664C83.5259 49.6664 90.5847 54.2912 104.772 54.3028L86.8293 86.8037C86.8293 86.8037 83.3404 95.1143 93.0304 109.047C102.732 122.967 61.5379 132.796 48.1388 113.301C34.7397 93.8046 15.9856 92.6571 16.8433 90.2809C17.7011 87.9048 17.1563 82.9555 18.1995 76.3835Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7703 245.688C68.7703 245.688 69.7439 250.846 71.6564 254.103C76.5362 250.649 77.8112 250.278 77.8112 250.278L81.6942 254.636C81.6942 254.636 90.1092 248.47 92.7171 242.547L102.477 215.169L68.5732 225.265L68.7703 245.688Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4158 243.138C92.5201 242.941 92.636 242.744 92.7171 242.547L102.477 215.169L68.5732 225.265L68.7587 244.517C79.8859 244.482 87.478 243.833 92.4158 243.138Z",
    fill: "white",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7266 43.6402C54.3966 51.1859 63.0666 43.3852 63.0666 43.3852C63.0666 43.3852 59.4618 34.4833 54.4777 35.1904C49.5631 36.2567 45.7382 42.2377 45.7382 42.2377V43.6402H45.7266Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8784 68.9883C46.7477 78.2726 54.5832 87.0469 63.0678 86.3167",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9009 70.4164C44.6163 68.5967 48.8818 69.663 48.8818 69.663",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5215 61.6716C45.2276 59.9865 47.5791 57.1843 46.7736 55.4128C45.9681 53.6413 42.3107 53.5713 38.6046 55.2564C34.8985 56.9416 32.547 59.7437 33.3525 61.5152C34.158 63.2867 37.8153 63.3567 41.5215 61.6716Z",
    fill: "#FFB49E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6636 42.5165C44.6636 42.5165 48.1757 36.2459 51.9427 34.4493C55.7097 32.6527 60.3461 35.1447 63.0583 43.3743C59.0247 36.8022 54.226 31.4125 47.2367 41.5893C46.5644 42.5629 45.5561 43.3511 44.6868 42.5397L44.6636 42.5165Z",
    fill: "#282750"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0342 44.9609C57.8458 44.9609 59.3144 42.7606 59.3144 40.0464C59.3144 37.3321 57.8458 35.1318 56.0342 35.1318C54.2225 35.1318 52.7539 37.3321 52.7539 40.0464C52.7539 42.7606 54.2225 44.9609 56.0342 44.9609Z",
    fill: "#282750"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4338 39.7101C58.9139 39.7101 59.3031 39.2171 59.3031 38.609C59.3031 38.0008 58.9139 37.5078 58.4338 37.5078C57.9537 37.5078 57.5645 38.0008 57.5645 38.609C57.5645 39.2171 57.9537 39.7101 58.4338 39.7101Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7712 46.2012C73.1876 49.8524 69.0381 42.9906 69.0381 42.9906C69.0381 42.9906 72.6892 37.5312 75.6797 38.8874C78.5658 40.4753 79.9914 45.2392 79.9914 45.2392L79.7712 46.2012Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1042 45.6205C80.1042 45.6205 79.1189 40.9842 77.2644 39.0833C75.4098 37.1824 71.7934 38.6544 69.0464 44.2528C72.7555 39.4773 76.3023 36.4637 78.8175 46.5014L80.1042 45.6205Z",
    fill: "#282750"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8574 42.486C78.0768 40.5846 77.3164 38.935 76.159 38.8015C75.0016 38.668 73.8856 40.1011 73.6662 42.0025C73.4469 43.9039 74.2073 45.5536 75.3647 45.6871C76.5221 45.8206 77.6381 44.3874 77.8574 42.486Z",
    fill: "#282750"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.003 41.5109C78.0464 41.0842 77.8338 40.7131 77.5281 40.682C77.2224 40.6509 76.9394 40.9716 76.896 41.3983C76.8526 41.825 77.0652 42.1961 77.3709 42.2272C77.6766 42.2583 77.9596 41.9376 78.003 41.5109Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2644 39.0963C75.4098 37.2069 72.2687 37.9951 69.0464 44.2658C72.7555 39.4903 76.3023 36.4767 78.8175 46.5144",
    fill: "#282750"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9653 21.5003C81.4499 22.4044 80.3256 17.5826 85.0894 19.2169C87.9872 20.2021 89.5056 27.8521 79.2012 27.8521",
    fill: "#282750"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4071 22.8224C61.0267 21.5126 63.0203 23.3903 61.1194 25.1985C59.2185 26.9951 54.2229 26.1026 51.9395 30.7737C52.3451 26.1721 58.4071 22.8224 58.4071 22.8224Z",
    fill: "#282750"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1867 25.8698C71.1815 24.8614 69.6515 26.3103 71.1119 27.6896C72.5724 29.0689 76.3858 28.3851 78.1476 31.9551C77.8347 28.443 73.1867 25.8698 73.1867 25.8698Z",
    fill: "#282750"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9576 39.0723C44.6626 41.7845 42.4951 40.0459 42.4951 40.0459C42.4951 40.0459 43.3761 41.8657 44.6974 42.5495C46.0188 43.2334 46.9576 40.1386 46.9576 40.1386",
    fill: "#282750"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8853 39.5362C45.6007 40.7301 46.8061 40.5678 46.8061 40.5678L48.6143 37.5078C48.6027 37.5078 46.9105 40.5678 43.8853 39.5362Z",
    fill: "#282750"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8096 46.0403C79.3775 47.1414 81.1857 45.2173 81.1857 45.2173C81.1857 45.2173 80.6294 45.3448 79.76 44.4175C78.8907 43.4903 79.2616 44.6378 79.2616 44.6378",
    fill: "#282750"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M110.128 134.118C112.887 130.061 114.428 124.59 111.843 118.145L84.8019 90.8603C84.8019 90.8603 99.0239 123.721 78.7978 113.509C61.0753 104.549 23.1614 63.3783 14.8739 88.6928C5.26503 130.559 12.0689 129.771 23.4975 167.963C29.1655 186.891 29.3973 207.245 26.291 228.572C50.4812 234.738 86.4478 237.845 97.1462 227.923C103.51 218.163 125.045 181.837 110.128 134.118Z",
    fill: "#FFCF47",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.128 134.118C112.887 130.061 114.428 124.59 111.843 118.145L84.8019 90.8603C84.8019 90.8603 99.0239 123.721 78.7978 113.509C61.0753 104.549 23.1614 63.3783 14.8739 88.6928C5.26503 130.559 12.0689 129.771 23.4975 167.963C29.1655 186.891 29.3973 207.245 26.291 228.572C50.4812 234.738 86.4478 237.845 97.1462 227.923C103.51 218.163 125.045 181.837 110.128 134.118Z",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.59 53.8635C89.3914 53.8519 82.3441 49.2271 82.3441 49.2271C82.3441 49.2271 86.227 27.4941 69.8491 19.4616C53.4711 11.4291 32.5148 17.8041 25.4559 41.5771C22.0018 53.2144 19.1505 68.2594 17.5625 87.0019",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5863 167.64C5.93516 171.673 3.06064 176.901 -6.90755 177.04C-7.61459 175.058 -7.92755 171.755 -7.92755 171.755L-11.6946 173.945C-12.0539 170.885 -12.2973 167.118 -11.1614 162.749C5.55267 98.2799 15.7874 86.2717 26.6829 88.4508C37.5783 90.6299 48.6709 101.039 43.7215 125.959C40.4065 142.604 18.6156 157.66 9.5863 167.64Z",
    fill: "white",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1784 65.1658C57.4007 88.4404 70.8925 93.2274 77.0009 91.1526C83.1209 89.0779 95.1291 89.7502 99.6032 91.6047C104.077 93.4477 107.253 88.9736 106.813 79.9095C106.372 70.8454 112.492 66.1511 109.212 57.6318C105.932 49.1124 97.8529 55.3367 87.6993 54.8963C77.5457 54.4558 70.7766 48.1272 63.6714 48.8922C56.5661 49.6572 52.9266 56.0902 54.1784 65.1658Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3728 60.1213C80.3968 65.3952 83.2945 63.9116 84.2102 65.8936C85.1259 67.8757 85.5779 72.0716 77.1629 69.7302C68.7595 67.3888 68.3887 59.1825 73.3728 60.1213Z",
    fill: "#282750"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3695 60.7491C95.3011 65.9766 92.9017 65.4782 92.6351 67.1009C92.3686 68.7237 92.8669 71.8648 98.5233 68.4918C104.168 65.1305 102.824 59.0916 99.3695 60.7491Z",
    fill: "#282750"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9166 20.9457C35.6902 20.2502 37.8694 9.36636 30.2309 12.5423C23.2532 15.4284 25.0151 25.3386 36.8494 25.7907",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9166 20.9457C35.6902 20.2502 37.8694 9.36636 30.2309 12.5423C23.2532 15.4284 25.0151 25.3386 36.8494 25.7907",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8715 23.0875C36.6524 21.5343 32.2363 16.4111 32.2363 16.4111C32.2363 16.4111 36.9886 22.6123 39.1561 23.3657C41.3236 24.1075 40.8715 23.0875 40.8715 23.0875Z",
    fill: "#282750"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5438 23.1239C33.4545 12.5414 40.5365 0 40.5365 0C40.4322 8.32227 44.8367 15.8448 51.374 18.4991C50.7481 22.5907 45.5438 23.1239 45.5438 23.1239Z",
    fill: "#282750"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1558 18.1517C71.9692 15.5205 73.2442 9.60916 71.4244 5.25098C71.4244 5.25098 78.773 12.0433 72.4908 20.5858C70.4623 19.473 68.1558 18.1517 68.1558 18.1517Z",
    fill: "#282750"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.7043 173.944L-7.93727 171.754C-7.93727 171.754 -7.62431 175.057 -6.91726 177.039C2.52933 176.911 6.19207 172.669 9.10139 168.357C9.0898 168.357 0.0604591 171.023 -10.7655 161.183C-10.9045 161.704 -11.032 162.214 -11.1711 162.736C-12.2955 167.117 -12.0636 170.884 -11.7043 173.944Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8926 32.8371C73.9515 38.3544 78.8197 25.5348 93.8763 37.5082C92.3463 38.7137 87.4085 53.3994 78.0431 50.4437C68.6776 47.488 70.8915 41.1478 68.1677 40.858C65.4322 40.5683 64.4006 47.5924 56.0435 49.4585C44.8004 51.9737 36.1304 34.3903 36.1304 34.3903C36.1304 34.3903 47.3967 17.5951 66.8926 32.8371Z",
    fill: "#282750",
    stroke: "white",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M125.498 94.1894L125.811 89.8428C124.444 90.318 121.94 91.9639 119.32 93.8648C122.148 98.1766 127.886 101.353 131.479 103.022C132.267 99.695 132.279 96.1714 130.691 92.7984C128.616 93.0187 125.498 94.1894 125.498 94.1894Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625977 123.79C10.5594 122.631 7.75438 118.377 9.09893 112.698C10.4435 107.018 10.8028 107.238 13.573 105.164C16.3432 103.089 12.5183 97.5137 12.5183 97.5137C12.5183 97.5137 4.77552 104.19 0.625977 123.79Z",
    fill: "#282750",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2541 147.585C22.3491 138.475 26.035 135.09 30.2541 134.765C34.4732 134.441 35.9916 131.381 37.4173 128.101C38.843 124.82 42.3318 130.558 42.3318 130.558C42.3318 130.558 36.8493 142.16 30.2541 147.585Z",
    fill: "#282750",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0581 30.1963C59.0581 30.1963 50.0288 39.272 46.5747 43.7693C47.4672 45.6934 51.1647 47.0843 51.1647 47.0843L63.2076 33.3258L63.3815 33.1288L59.0581 30.1963Z",
    fill: "white",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M55.338 29.5571L44.2802 41.0321L42.9009 39.4325L53.8659 28.9775L55.338 29.5571Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6999 36.4443C87.4565 36.9775 80.1079 48.6496 80.1079 48.6496C80.1079 48.6496 84.8602 47.9077 86.7727 44.558C88.6852 41.1966 90.644 37.9627 90.644 37.9627L87.6999 36.4443Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8064 35.1453C78.4819 35.4698 72.2459 42.946 72.0836 42.5403C71.9214 42.1346 70.7739 40.0482 70.7739 40.0482L74.3323 36.2348C74.3439 36.2348 76.6505 34.8439 78.8064 35.1453Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M107.033 113.358C111.241 110.68 109.606 109.614 109.236 106.96C108.865 104.294 108.262 105.65 109.861 103.934C111.449 102.219 110.186 101.35 110.186 101.35C110.186 101.35 103.857 106.566 103.799 106.612C103.741 106.658 103.591 107.736 103.591 107.736",
    fill: "#282750"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1396 80.7549C22.3008 77.7992 28.0847 76.4895 27.2154 74.9595C26.346 73.4295 22.7876 72.1776 22.9615 68.9901C23.1238 65.791 24.0047 66.2315 23.9467 64.5392C23.8888 62.8469 20.7592 61.8965 20.7592 61.8965",
    fill: "#282750"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6006 97.7912C76.224 108.791 87.7569 105.858 86.5747 95.6816",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8502 112.56C87.075 112.089 87.3988 109.968 86.5736 107.824C85.7483 105.679 84.0865 104.322 82.8617 104.793C81.6369 105.264 81.313 107.385 82.1383 109.53C82.9636 111.675 84.6254 113.032 85.8502 112.56Z",
    fill: "#282750"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 137.377C66.5677 144.25 75.4231 143.497 78.6454 142.094",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5366 221.988C83.1896 209.991 94.9891 181.489 94.9891 181.489",
    stroke: "#282750",
    strokeWidth: 0.761335,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3324 131.93C38.3799 140.588 22.1062 161.185 22.1062 161.185L19.9619 156.862L34.6824 142.211",
    fill: "#282750"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M126.69 152.502C126.435 152.873 126.69 184.111 126.69 184.111H127.258L128.939 151.899",
    fill: "#282750"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9352 60.4709C53.9004 85.797 61.9908 90.1436 72.2488 92.0097C64.7495 88.8454 60.797 84.209 60.797 84.209C60.797 84.209 55.5695 73.754 55.6738 72.8615C55.7781 71.969 54.0047 60.042 54.0047 60.042",
    fill: "#282750"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs1);
export default __webpack_public_path__ + "static/media/contactUs1.926e80672197d40c5e4d4fa17423e722.svg";
export { ForwardRef as ReactComponent };